import { render, staticRenderFns } from "./admin-details-activity-in-dnd.vue?vue&type=template&id=0b49613d&scoped=true&"
import script from "./admin-details-activity-in-dnd.vue?vue&type=script&lang=js&"
export * from "./admin-details-activity-in-dnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49613d",
  null
  
)

export default component.exports